import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { Link } from 'react-router-dom';
import AuthService from '../../services/AuthService';
import DocumentHelper from '../../helpers/DocumentHelper';

class Settings extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false
        }

        this.toggle = this.toggle.bind(this);
        this.toggleKeyup = this.toggleKeyup.bind(this);
        this.onDropdownClick = this.onDropdownClick.bind(this);
        this.onDropdownClickKeyup = this.onDropdownClickKeyup.bind(this);
        this.closeDropdown = this.closeDropdown.bind(this);
    }

    componentDidMount() {
        document.addEventListener('click', this.closeDropdown);
    }

    closeDropdown(e) {
        const trg = e.target;
        const cls = 'global-settings-dropdown';

        if (trg.classList.contains(cls) || trg.classList.contains('fa-cog') || DocumentHelper.closest(trg, '.' + cls)) return;
        else this.setState({ open: false });
    }

    toggle() {
        this.setState({ open: !this.state.open });
    }

    toggleKeyup(e) {
        if (e.keyCode === 13) this.toggle();
    }

    onDropdownClick(e) {
        e.preventDefault();
        const url = e.target.dataset.url;

        this.setState({ open: false }, () => {
            if (url) {
                if (url === 'login') AuthService.logout();
                this.props.history.push('/' + url);
            }
        });
    }

    onDropdownClickKeyup(e) {
        if (e.keyCode === 13) this.onDropdownClick(e);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.closeDropdown)
    }

    render() {
        return (
            <div className={'global-settings' + (this.state.open ? ' open' : '')}>
                <i className="fa fa-cog" id="settings-ttip" onClick={this.toggle} tabIndex="0" onKeyUp={this.toggleKeyup}></i>
                <UncontrolledTooltip placement="top" target={'settings-ttip'} >Settings</UncontrolledTooltip>
                <div className="global-settings-dropdown">
                    <div className="global-settings-dropdown-title  small-caps">Settings</div>
                    <div 
                        className="global-settings-dropdown-item" 
                        data-url="preferences" 
                        onClick={this.onDropdownClick}
                        tabIndex="0"
                        onKeyUp={this.onDropdownClickKeyup}
                    >
                        <i className="fa fa-user"></i>Preferences
                    </div>
                    <div 
                        className="global-settings-dropdown-item" 
                        data-url="login" 
                        onClick={this.onDropdownClick}
                        tabIndex="0"
                        onKeyUp={this.onDropdownClickKeyup}
                    >
                        <i className="fa fa-lock"></i>Logout
                    </div>
                </div>
            </div>
        )
    }
}

export default Settings;


// WEBPACK FOOTER //
// ./src/components/Header/Settings.js